import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        style: {
          background: '#FFFFFF',
          color: '#0F172A',
          border: '1px solid #DCFCE7',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-600",
          actionButton:
            "group-[.toast]:bg-emerald-500 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-600",
          success: "!bg-white !text-emerald-800 !border-emerald-200",
          error: "!bg-white !text-red-800 !border-red-200",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
